
import React, { useState, useEffect } from 'react';
import './App.css';
import { IMAGE } from './utils/Theme';
import Login from './auth/Login';
import { HashRouter, Route, Routes } from 'react-router-dom';
import DefaultLayouts from './layouts/DefaultLayouts';
import PrivateRoute from './utils/PrivateRoute'
import PublicRoute from './utils/PublicRoute'
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing
      e.preventDefault();
      // Save the event so it can be triggered later
      setDeferredPrompt(e);
      // Update UI to show install button
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for the user's response
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        // Clear the saved prompt
        setDeferredPrompt(null);
      });
    }
  };

  const handleCancelInstall = () => {
    // Cancel the event
    setDeferredPrompt(null);  // Reset the deferredPrompt to cancel the prompt
    setIsInstallable(false);  // Optionally hide the install button
    console.log("Install prompt has been canceled.");
  };

  return (
    <>
    {isInstallable && (
          <div className='addto-homescreen'>
            <div className='addto-homescreen-inner'>
            <h3>Add to Home Screen</h3>
            <div className='log-info'>
                  <img src={IMAGE.logo5}/>
                  <h5>A-ride</h5>
              </div>
              <div className='home-btn'>
              <button onClick={handleCancelInstall} className="btn btn-sm btn-outline-danger mr-2">
             Cancel
            </button>
              <button onClick={handleInstallClick} className="btn btn-sm btn-success">
              Install App
            </button>
                </div>
                </div>
          </div>
        )}
     <HashRouter>
      
        <Routes>
        <Route element={<PrivateRoute />}> 
          <Route exact path="/" name="Login Page" element={<Login />} />
          <Route path="/forgot-password" name="forgot" element={<ForgotPassword />} />
          <Route path="/reset-password" name="reset" element={<ResetPassword />} />
        </Route>
        <Route element={<PublicRoute />}> 
          <Route path="*" name="Home" element={<DefaultLayouts />} />
        </Route>
        </Routes>
     
    </HashRouter>
    </>
   
  );
}

export default App;
